"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUnscopeUserClient = void 0;
var getUnscopeUserRefClient_1 = require("../get/getUnscopeUserRefClient");
var firestore_1 = require("firebase/firestore");
var setUnscopeUserClient = function (_a) {
    var firestore = _a.firestore, userId = _a.userId, unscopeUser = _a.unscopeUser, merge = _a.merge;
    var unscopeUserRef = (0, getUnscopeUserRefClient_1.getUnscopeUserRefClient)({
        firestore: firestore,
        userId: userId,
    });
    return (0, firestore_1.setDoc)(unscopeUserRef, unscopeUser, { merge: merge });
};
exports.setUnscopeUserClient = setUnscopeUserClient;
